import { useEffect, useState } from 'react';

import { fetchClientConfig } from '@/api/endpoints/config';
import type { ClientConfig } from '@/types/config';

export type AppConfigState =
  | { readonly status: 'idle' }
  | { readonly status: 'loading' }
  | { readonly status: 'success'; readonly data: ClientConfig }
  | { readonly status: 'error'; readonly message: string };

export function useAppConfig(): AppConfigState {
  const [state, setState] = useState<AppConfigState>({ status: 'idle' });

  useEffect(() => {
    let cancelled = false;
    setState({ status: 'loading' });
    fetchClientConfig()
      .then((data) => {
        if (!cancelled) {
          setState({ status: 'success', data });
        }
      })
      .catch((error: unknown) => {
        if (!cancelled) {
          setState({
            status: 'error',
            message: error instanceof Error ? error.message : 'unknown error',
          });
        }
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return state;
}
